import { createUseStyles } from 'react-jss';
import { TextColors } from '@picsart/design-system/foundation/textColors';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { textOverflowHidden } from '@picsart/design-system/styleHelpers/textOverflowHidden';

const useStyles = createUseStyles(
  {
    actionButton: {
      padding: Spacings.s12,
      background: BackgroundColors.tint1,
    },
    userCard: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s12,
      padding: `${Spacings.s4} ${Spacings.s16} ${Spacings.s16}`,
    },
    userInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s2,
      minWidth: 0,
      flex: 1,
    },
    userName: {
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.semibold,
      lineHeight: LineHeights.l24,
      color: TextColors.base,
      display: 'block',
      ...textOverflowHidden,
    },
    userHandle: {
      fontSize: FontSizes.s14,
      lineHeight: LineHeights.l20,
      color: TextColors.tint2,
      display: 'block',
      ...textOverflowHidden,
    },
    menuSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s4,
      padding: `0 ${Spacings.s8}`,
    },
    creditsRow: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: Spacings.s8,
    },
    creditsValue: {
      fontSize: FontSizes.s14,
      color: TextColors.tint2,
    },
  },
  { name: 'user-menu-content' }
);

export default useStyles;
